import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { FollowUpTutorialsList } from '@/follow-up-tutorials/FollowUpTutorialsList';

/**
 * The Follow-Up Tutorials archive, a bare post grid.
 *
 * No page heading, as legacy's archive has none. `?search_term=` is honoured
 * with no search box, as in legacy, whose sidebar here has no search widget.
 */
function FollowUpTutorialsArchive(): ReactElement {
  const { search_term } = Route.useSearch();

  return <FollowUpTutorialsList searchTerm={search_term} />;
}

export const Route = createFileRoute('/_app/follow-up-tutorials/')({
  component: FollowUpTutorialsArchive,
  // Legacy's parameter name.
  validateSearch: (
    search: Record<string, unknown>,
  ): { search_term?: string } => ({
    search_term: search.search_term ? `${search.search_term}` : undefined,
  }),
});
